import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Section from "../../parts/Section";
import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import classNames from "classnames";
import { SelectBlock } from "../../parts/FormBlocks";
import moment from "moment";
import _ from "lodash";
import { Company } from "../../types";
import Api from "../../Api";
import DiscreetMessage from "../../parts/DiscreetMessage";

const FinanceHub = () => {
  const navigate = useNavigate();
  const [expandReports, setExpandReports] = useState(false);

  return (
    <Section className="flex flex-col gap-8 p-8">
      <BigButton label="Notas" onClick={() => navigate("/financeiro/notas")} />

      <BigButton
        label="Contratos"
        onClick={() => navigate("/financeiro/contratos/clientes")}
      />

      <BigButton
        label="Recibos"
        onClick={() => navigate("/financeiro/recibos/clientes")}
      />

      <div className="border rounded-lg">
        <div
          className={classNames(
            "font-extrabold text-xl flex cursor-pointer hover:bg-slate-50",
            {
              "rounded-t-lg": expandReports,
              "rounded-lg": !expandReports,
            }
          )}
          onClick={() => setExpandReports(!expandReports)}
        >
          <span className="flex-1 py-4 px-6">Relatórios</span>
          <span className="py-4 px-6">
            <FontAwesomeIcon
              icon={!expandReports ? "chevron-down" : "chevron-up"}
            />
          </span>
        </div>

        {expandReports && <ReportForm />}
      </div>
    </Section>
  );
};

export default FinanceHub;

const BigButton = ({
  label,
  onClick,
}: {
  label: string;
  onClick: () => void;
}) => (
  <div
    className="border rounded-lg font-extrabold text-xl flex cursor-pointer hover:bg-slate-50"
    onClick={onClick}
  >
    <span className="flex-1 py-4 px-6">{label}</span>
    <span className="border-l py-4 px-6">
      <FontAwesomeIcon icon={"chevron-right"} />
    </span>
  </div>
);

const ReportForm = () => {
  const [companies, setCompanies] = useState<Company[] | null>(null);
  const [month, setMonth] = useState(moment().format("MM"));
  const [year, setYear] = useState(moment().year().toString());
  const [company, setCompany] = useState("");

  useEffect(() => {
    Api.getCompanies().then((companies) => [
      setCompanies(companies),
      setCompany(companies[0].uuid),
    ]);
  }, []);

  const generate = () => {
    window.open(`/financeiro/relatorio/${company}/${year}/${month}`);
  };

  if (!companies) {
    return <DiscreetMessage text="Carregando ..." />;
  }

  return (
    <div className="p-4 border-t flex flex-col gap-4">
      <SelectBlock
        label="Empresa"
        options={companies.map((company) => ({
          label: company.shortName,
          value: company.uuid,
        }))}
        value={company}
        onChange={setCompany}
      />

      <SelectBlock
        label="Mês"
        options={months}
        value={month}
        onChange={setMonth}
      />

      <SelectBlock
        label="Ano"
        options={years}
        value={year}
        onChange={setYear}
      />

      <hr />

      <button
        className="rounded bg-sky-600 hover:bg-sky-500 text-white font-extrabold p-2"
        onClick={generate}
      >
        Gerar
      </button>
    </div>
  );
};

const months = [
  { label: "Janeiro", value: "01" },
  { label: "Fevereiro", value: "02" },
  { label: "Março", value: "03" },
  { label: "Abril", value: "04" },
  { label: "Maio", value: "05" },
  { label: "Junho", value: "06" },
  { label: "Julho", value: "07" },
  { label: "Agosto", value: "08" },
  { label: "Setembro", value: "09" },
  { label: "Outubro", value: "10" },
  { label: "Novembro", value: "11" },
  { label: "Dezembro", value: "12" },
];

const years = _.range(2013, moment().year() + 1).map((y) => ({
  label: y.toString(),
  value: y.toString(),
}));
